import React from "react";
import { Link } from "react-router-dom";
import { Story } from "./types";
// One project card, three sizes: `lead` (home page lead feature: image left,
// text right), `compact` (the two supporting features below it: text only)
// and the default grid card. Grid and lead cards always have an image: the
// published Insight's, else the cached Wiki home preview, else a placeholder.
export default function StoryCard({
  story,
  lead = false,
  compact = false,
}: {
  story: Story;
  lead?: boolean;
  compact?: boolean;
}) {
  const kicker = (story.hasInsight ? "Insight" : "Team Wiki") + " · iDEC " + story.year;
  return (
    <article
      className={
        "er-story" + (lead ? " er-lead" : "") + (compact ? " er-compact" : "")
      }
      data-image={story.imageKind}
    >
      {!compact && (
        <figure>
          <a href={story.wikiUrl} target="_blank" rel="noopener noreferrer">
            <img src={story.imageUrl} alt={story.imageAlt} loading={lead ? undefined : "lazy"} />
          </a>
          {story.imageCredit && <figcaption>{story.imageCredit}</figcaption>}
        </figure>
      )}
      <div className="er-story-text">
        <div className="er-kicker">{kicker}</div>
        <h3>
          <a href={story.wikiUrl} target="_blank" rel="noopener noreferrer">
            {story.headline}
          </a>
        </h3>
        <p className="er-team">{story.team}</p>
        {story.summary && <p className="er-deck">{story.summary}</p>}
        <div className="er-links">
          <a href={story.wikiUrl} target="_blank" rel="noopener noreferrer">
            Explore Wiki ↗
          </a>
          {story.articles.map((a, i) => (
            <a key={a.articleId} href={a.url}>
              Read preprint{story.articles.length > 1 ? " " + (i + 1) : ""} →
            </a>
          ))}
          {story.relatedArticles && (
            <Link className="er-blog-link" to={story.relatedArticles.url}>
              Related articles ({story.relatedArticles.count}) →
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}
